(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~timeline"],{

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "TimelineProps", function() { return /* reexport */ TimelineProps; });
__webpack_require__.d(__webpack_exports__, "TimeLineItemProps", function() { return /* reexport */ TimeLineItemProps; });

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// CONCATENATED MODULE: ./src/components/timeline/TimelineItem.jsx
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var TimeLineItemProps = {
  prefixCls: vue_types["a" /* default */].string,
  color: vue_types["a" /* default */].string,
  dot: vue_types["a" /* default */].any,
  pending: vue_types["a" /* default */].bool,
  position: vue_types["a" /* default */].oneOf(['left', 'right', '']).def(''),
  mode: vue_types["a" /* default */].oneOf(['left', 'alternate', 'right', 'megBoth', 'megCard', ''])
};
/* harmony default export */ var TimelineItem = ({
  name: 'MegTimelineItem',
  props: Object(props_util["initDefaultProps"])(TimeLineItemProps, {
    color: 'blue',
    pending: false
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  render: function render() {
    var _classNames,
        _classNames2,
        _this = this;

    var h = arguments[0];

    var _getOptionProps = Object(props_util["getOptionProps"])(this),
        customizePrefixCls = _getOptionProps.prefixCls,
        _getOptionProps$color = _getOptionProps.color,
        color = _getOptionProps$color === void 0 ? '' : _getOptionProps$color,
        pending = _getOptionProps.pending;

    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('timeline', customizePrefixCls);
    var slotDefault = this.$slots.right ? this.$slots.right : this.$slots.default;
    var dot = Object(props_util["getComponentFromProp"])(this, 'dot');
    var mode = Object(props_util["getComponentFromProp"])(this, 'mode');
    console.log('mode', mode);
    var itemClassName = external_classnames_default()((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-item-pending"), pending), _classNames));
    var dotClassName = external_classnames_default()((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-item-head"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-custom"), dot), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-").concat(color), true), _classNames2));
    var liProps = {
      class: itemClassName,
      on: Object(props_util["getListeners"])(this)
    };

    var renderModeEle = function renderModeEle(mode) {
      switch (mode) {
        case 'megBoth':
          return h("div", {
            "class": "".concat(prefixCls, "-item-content")
          }, [h("div", {
            "class": "".concat(prefixCls, "-item-content-left")
          }, [_this.$slots.left]), h("div", {
            "class": "".concat(prefixCls, "-item-content-right")
          }, [slotDefault])]);

        case 'megCard':
          return h("div", {
            "class": "".concat(prefixCls, "-item-content")
          }, [h("div", {
            "class": "".concat(prefixCls, "-item-content-card")
          }, [_this.$slots.card || slotDefault])]);

        default:
          return h("div", {
            "class": "".concat(prefixCls, "-item-content")
          }, [_this.$slots.default]);
      }
    };

    return h("li", liProps, [h("div", {
      "class": "".concat(prefixCls, "-item-tail")
    }), h("div", {
      "class": dotClassName,
      style: {
        borderColor: /blue|red|green|gray/.test(color) ? undefined : color
      }
    }, [dot]), renderModeEle(mode)]);
  }
});
// CONCATENATED MODULE: ./src/components/timeline/Timeline.jsx
var _excluded = ["prefixCls", "reverse", "mode"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Timeline_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function Timeline_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var TimelineProps = {
  prefixCls: vue_types["a" /* default */].string,

  /** 指定最后一个幽灵节点是否存在或内容 */
  pending: vue_types["a" /* default */].any,
  pendingDot: vue_types["a" /* default */].string,
  reverse: vue_types["a" /* default */].bool,
  mode: vue_types["a" /* default */].oneOf(['left', 'alternate', 'right', 'megBoth', 'megCard', ''])
};
/* harmony default export */ var Timeline = ({
  name: 'MegTimeline',
  props: Object(props_util["initDefaultProps"])(TimelineProps, {
    reverse: false,
    mode: ''
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  render: function render() {
    var _classNames;

    var h = arguments[0];

    var _getOptionProps = Object(props_util["getOptionProps"])(this),
        customizePrefixCls = _getOptionProps.prefixCls,
        reverse = _getOptionProps.reverse,
        mode = _getOptionProps.mode,
        restProps = _objectWithoutProperties(_getOptionProps, _excluded);

    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('timeline', customizePrefixCls);
    var pendingDot = Object(props_util["getComponentFromProp"])(this, 'pendingDot');
    var pending = Object(props_util["getComponentFromProp"])(this, 'pending');
    var pendingNode = typeof pending === 'boolean' ? null : pending;
    var classString = external_classnames_default()(prefixCls, (_classNames = {}, Timeline_defineProperty(_classNames, "".concat(prefixCls, "-pending"), !!pending), Timeline_defineProperty(_classNames, "".concat(prefixCls, "-reverse"), !!reverse), Timeline_defineProperty(_classNames, "".concat(prefixCls, "-").concat(mode), !!mode), _classNames));
    var children = Object(props_util["filterEmpty"])(this.$slots.default); // // Remove falsy items
    // const falsylessItems = filterEmpty(this.$slots.default)
    // const items = falsylessItems.map((item, idx) => {
    //   return cloneElement(item, {
    //     props: {
    //       last: falsylessItems.length - 1 === idx,
    //     },
    //   })
    // })

    var pendingItem = pending ? h(TimelineItem, {
      attrs: {
        pending: !!pending
      }
    }, [h("template", {
      slot: "dot"
    }, [pendingDot || h("meg-icon", {
      attrs: {
        name: "megui-loading"
      }
    })]), pendingNode]) : null;
    var timeLineItems = reverse ? [pendingItem].concat(_toConsumableArray(children.reverse())) : [].concat(_toConsumableArray(children), [pendingItem]);

    var getPositionCls = function getPositionCls(ele, idx) {
      var eleProps = Object(props_util["getPropsData"])(ele);
      console.log('eleProps:', eleProps);

      if (mode === 'alternate') {
        if (eleProps.position === 'right') return "".concat(prefixCls, "-item-right");
        if (eleProps.position === 'left') return "".concat(prefixCls, "-item-left");
        return idx % 2 === 0 ? "".concat(prefixCls, "-item-left") : "".concat(prefixCls, "-item-right");
      }

      if (mode === 'left') return "".concat(prefixCls, "-item-left");
      if (mode === 'right') return "".concat(prefixCls, "-item-right");
      if (eleProps.position === 'right') return "".concat(prefixCls, "-item-right");
      return '';
    }; // Remove falsy items


    var truthyItems = timeLineItems.filter(function (item) {
      return !!item;
    });
    var itemsCount = truthyItems.length;
    var lastCls = "".concat(prefixCls, "-item-last");
    var items = truthyItems.map(function (ele, idx) {
      var pendingClass = idx === itemsCount - 2 ? lastCls : '';
      var readyClass = idx === itemsCount - 1 ? lastCls : '';
      return Object(vnode["a" /* cloneElement */])(ele, {
        class: external_classnames_default()([!reverse && !!pending ? pendingClass : readyClass, getPositionCls(ele, idx)]),
        props: {
          mode: mode
        }
      });
    });
    var timelineProps = {
      props: _objectSpread({}, restProps),
      class: classString,
      on: Object(props_util["getListeners"])(this)
    };
    return h("ul", timelineProps, [items]);
  }
});
// EXTERNAL MODULE: ./src/base/base/index.js
var base = __webpack_require__(19);

// CONCATENATED MODULE: ./src/components/timeline/index.jsx





Timeline.Item = TimelineItem;
/* istanbul ignore next */

Timeline.install = function (Vue) {
  Vue.use(base["a" /* default */]);
  Vue.component(Timeline.name, Timeline);
  Vue.component(TimelineItem.name, TimelineItem);
};

/* harmony default export */ var timeline = __webpack_exports__["default"] = (Timeline);

/***/ })

}]);